// extracted by mini-css-extract-plugin
export default {"root":"jmy753gF2iOHKBXOe29Q","ru":"R_w15BEgDibzLgOt5xEc","kg":"_RYAc3Jtcmfq7jgMQjdj","kk":"KRsbBiXdN8ETACF3rGKK","placeHolderShimmer":"oaL2ANfzS4HjiG58O1yy"};